import {
  CLEAR_SELECTED_DATE,
  DATE_PAGE_NEXT,
  DATE_PAGE_PREV,
  RECEIVE_DATES,
  SELECT_DATE,
  SAVE_SLIDER_POSITION,
  SET_EXTRA_LIFE,
  SET_EXTRA_LIFE_AUTO_COMPLETE
} from '../actions/date';
import { RESET_APP } from '../actions/index';

const initialState = {
  futureAvailabilityData: [],
  selectedDatePage: 0,
  selectedDate: null,
  lastSliderPosition: 0,
  lastCurrentMonth: null,
  done: false,
  isExtraLife: false,
  extraLifeAutoComplete: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_SELECTED_DATE:
      return { ...state, selectedDate: null, lastSliderPosition: 0, done: false };
    case RECEIVE_DATES:
      return { ...state, futureAvailabilityData: action.dates };
    case RESET_APP:
      return { ...initialState };
    case SELECT_DATE:
      return { ...state, selectedDate: action.date, done: true };
    case DATE_PAGE_NEXT:
      return { ...state, selectedDatePage: state.selectedDatePage + 1 };
    case DATE_PAGE_PREV:
      return { ...state, selectedDatePage: state.selectedDatePage - 1 };
    case SAVE_SLIDER_POSITION:
      return { ...state, lastSliderPosition: action.sliderPosition };
    case SET_EXTRA_LIFE:
      return { ...state, isExtraLife: true };
    case SET_EXTRA_LIFE_AUTO_COMPLETE:
      return { ...state, extraLifeAutoComplete: action.isAutoComplete}
    default:
      return state;
  }

};
